import React, { useState, useEffect } from 'react';
import { Modal, Input, List, Spin, message } from 'antd';
import { useEpisode } from '../contexts/EpisodeContext';
import useGraphqlService from "../util/useGraphqlService";
import {GET_EPISODES_QUERY} from "../constants/graphql/episodeQueries";
import StyledListItem from "./styled/StyledListItem";

const EpisodeManager = () => {
    const { episode, updateEpisode } = useEpisode();
    const { sendGraphqlRequest, loading } = useGraphqlService();
    const [episodes, setEpisodes] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);

    // Effect to automatically fetch episodes when the modal is shown
    useEffect(() => {
        if (!episode) {
            setIsModalVisible(true);
            episode?.id && fetchEpisodes("");  // Fetch all episodes immediately when the modal is shown
        }
    }, [episode]);

    // Effect to handle automatic fetching of episodes
    useEffect(() => {
        if (isModalVisible) {
            fetchEpisodes("");  // Run this to fetch all episodes when modal opens
        }
    }, [isModalVisible]);

    const fetchEpisodes = async (installment) => {
        let variables = {};
        const installmentInt = parseInt(installment, 10);

        if (!isNaN(installmentInt)) {
            variables.installment = installmentInt;
        }

        try {
            const data = await sendGraphqlRequest(GET_EPISODES_QUERY, variables);
            setEpisodes(data.episodes);
        } catch (error) {
            console.error('Failed to fetch episodes:', error);
            message.error("Failed to fetch episodes.");
        }
    };

    const handleSelectEpisode = (ep) => {
        updateEpisode(ep);
        setIsModalVisible(false);
    };

    return (
        <Modal
            title="Select an Episode"
            visible={isModalVisible}
            onOk={() => {}}
            onCancel={() => {}}
            footer={null}
            maskClosable={false}
            closable={false}
        >
            <Input.Search
                placeholder="Enter installment number to search (optional)"
                enterButton="Search"
                onSearch={fetchEpisodes}
            />
            {loading ? (
                <Spin size="large" style={{ display: 'block', textAlign: 'center', margin: '20px 0' }} />
            ) : (
                <List
                    itemLayout="horizontal"
                    dataSource={episodes}
                    renderItem={item => (
                        <StyledListItem onClick={() => handleSelectEpisode(item)}>
                            <List.Item.Meta title={item.installment} />
                        </StyledListItem>
                    )}
                />
            )}
        </Modal>
    );
};

export default EpisodeManager;
